import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'createdDateTime';
export const apiKey = 'CreatedDateTime';
export const type = TYPE_DATE_COMPARISON;

export const createdDateTime = {
  id,
  apiKey,
  type,
};
